import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import globalStyles from '@lib/core/src/styles/globalStyles';
import { theme } from '@lib/core/src/theme/theme';
import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LogRocket from 'logrocket';

import App from './app/app';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import PostHogProvider from './providers/PostHog/PostHogProvider';

const logRocketKey = process.env.VITE_LOGROCKET_PROJECT_ID;
if (logRocketKey && !window.opener) {
  // Only initialize LogRocket in main window, not in popup windows
  LogRocket.init(logRocketKey);
}

Sentry.init({
  dsn: process.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: process.env.PROD ? 0.1 : 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const queryClient = new QueryClient();
root.render(
  <PostHogProvider>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <GlobalStyles styles={globalStyles} />
        <ThemeProvider theme={theme}>
          <ErrorBoundary>
            <CssBaseline />
            <App />
          </ErrorBoundary>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </PostHogProvider>
);
